import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "wo-props-container"
};
const _hoisted_2 = {
  key: 0,
  class: "list-container"
};
const _hoisted_3 = {
  key: 0,
  class: "wo-props-list"
};
const _hoisted_4 = {
  key: 1,
  class: "empty-data-tips"
};
const _hoisted_5 = {
  key: 1,
  class: "list-container"
};
const _hoisted_6 = {
  key: 0,
  class: "record-stat-container"
};
const _hoisted_7 = {
  class: "stat-time"
};
const _hoisted_8 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_9 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_10 = {
  class: "wo-records-list"
};
const _hoisted_11 = {
  key: 1,
  class: "empty-data-tips"
};
const _hoisted_12 = {
  key: 2,
  class: "pagination-container"
};
import { ref, computed, onMounted, watch } from 'vue';
import { ElMessage, ElProgress } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import PropsCard from '@/components/Props/PropsCard.vue';
import MarketPropsCard from '@/components/Props/MarketPropsCard.vue';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import { pageStyle } from "@/theme/sliderStyle";
import MarketPropsHeader from "@/components/Props/MarketPropsHeader.vue";
import MarketTransactionCard from "@/components/Transaction/MarketTransactionCard.vue";
import { getPercentage, gradientPercentageColors, isUserType } from "@/tools/utils"; // refs

export default {
  __name: 'MarketPage',

  setup(__props) {
    const marketMode = ref(true);
    const dataArray = ref([]);
    const marketProp = ref(null);
    const recordStatData = ref(null);
    const pagerCount = ref(5);
    const size = ref(21); // const size = ref(7)

    const total = ref(0);
    const page = ref(0);
    const cacheFilterInfo = ref({}); // computed

    const worldOutlook = computed(() => store.state.world_outlook ? store.state.world_outlook : null);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const roleArray = computed(() => store.state.role_array ?? null);
    const marketChannels = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.market_channels ?? null;
    });
    const maxRecordCount = computed(() => {
      if (marketMode.value || !recordStatData.value) return 0;
      return Math.max(...recordStatData.value.map(item => item.count));
    });
    const maxRecordTotal = computed(() => {
      if (marketMode.value || !recordStatData.value) return 0;
      return Math.max(...recordStatData.value.map(item => item.total));
    }); // functions

    const getMarketData = (filterInfo = null) => {
      if (!worldOutlook.value) return;
      if (!marketChannels.value) return;
      let parameters = {
        'world_outlook_id': worldOutlook.value.id,
        'page': page.value,
        'size': size.value
      };

      if (filterInfo) {
        cacheFilterInfo.value = filterInfo;
        Object.entries(filterInfo).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } else if (Object.keys(cacheFilterInfo.value).length !== 0) {
        Object.entries(cacheFilterInfo.value).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } // console.log(JSON.stringify(parameters))


      request('market_channel/props/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        dataArray.value = response.data.props;
        total.value = response.data.numbers;
      });
    };

    const getRecordData = (filterInfo = null) => {
      let parameters = {
        'world_outlook_id': worldOutlook.value.id,
        'page': page.value,
        'size': size.value
      };

      if (filterInfo) {
        cacheFilterInfo.value = filterInfo;
        Object.entries(filterInfo).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } else if (Object.keys(cacheFilterInfo.value).length !== 0) {
        Object.entries(cacheFilterInfo.value).forEach(item => {
          parameters[item[0]] = item[1];
        });
      }

      request('transaction/market_transaction/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        dataArray.value = response.data.records;
        total.value = response.data.numbers;
      });
    };

    const getRecordStatData = () => {
      const parameters = {
        'world_outlook_id': worldOutlook.value.id
      };
      request('transaction/market_transaction/stat/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        // console.log(response.data.records.length, response.data.numbers)
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        recordStatData.value = response.data;
      });
    };

    const updateFilter = filterInfo => {
      page.value = 0;

      if (marketMode.value) {
        getMarketData(filterInfo);
      } else {
        getRecordData(filterInfo);
      }
    };

    const updateMode = isMarket => {
      page.value = 0;
      size.value = isMarket ? 21 : 6;
      marketMode.value = isMarket;
      cacheFilterInfo.value = {};
      dataArray.value = [];
      total.value = 0;

      if (isMarket) {
        getMarketData();
      } else {
        getRecordData();
        getRecordStatData();
      }
    }; // const getTransactionInfo = () => {
    //   // todo 后续考虑增加结社购物可能，花费结社公共资金，提供给结社成员卡，或者做结社公共仓库，设计未定
    //   // todo 后续考虑增加链接者购物可能，不花费资产点，但需要通过审核
    //   if (this.userType === 3) {
    //     request('transaction/get_transaction_info/', {}, 'POST').then(response => {
    //       // console.log(JSON.stringify(response))
    //
    //       if (response.code === 0) {
    //         this.dataArray = response.data.props
    //         this.total = response.data.numbers
    //       }
    //     })
    //   }
    // }


    const handlePageChange = index => {
      page.value = index - 1;

      if (marketMode.value) {
        getMarketData();
      } else {
        getRecordData();
      }
    };

    const selectedProp = item => {
      marketProp.value = item;
    };

    const closeProp = () => {
      marketProp.value = null;
    }; // lifecycle


    onMounted(() => {
      if (isUserType(userType.value)) {
        if (!roleArray.value) store.dispatch('get_roles');
      }

      getMarketData();
    }); // watcher

    watch(() => marketChannels.value, (newValue, oldValue) => {
      if (newValue && !oldValue) {
        getMarketData();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(MarketPropsHeader, {
        onUpdateFilter: updateFilter,
        onUpdateMode: updateMode
      }), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), marketMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [dataArray.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createBlock(PropsCard, {
          key: key,
          data: item,
          "pocket-mode": false,
          onClick: $event => selectedProp(item)
        }, null, 8, ["data", "onClick"]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [_createElementVNode("text", {
        style: {
          "display": "flex"
        }
      }, "未发现商品数据", -1)]))]))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [dataArray.value.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [recordStatData.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordStatData.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "stat-card"
          }, [_createElementVNode("text", _hoisted_7, _toDisplayString(item.time), 1), _createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(item.count, maxRecordCount.value),
            "text-inside": false,
            color: _unref(gradientPercentageColors),
            "stroke-width": 16
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_8, " 购买 " + _toDisplayString(item.count), 1)]),
            _: 2
          }, 1032, ["percentage", "color"]), _createVNode(_unref(ElProgress), {
            percentage: _unref(getPercentage)(item.total, maxRecordTotal.value),
            "text-inside": false,
            color: _unref(gradientPercentageColors),
            "stroke-width": 16
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_9, " 支出 " + _toDisplayString(item.total.toFixed(1)), 1)]),
            _: 2
          }, 1032, ["percentage", "color"])]);
        }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
          return _openBlock(), _createBlock(MarketTransactionCard, {
            key: key,
            data: item
          }, null, 8, ["data"]);
        }), 128))])]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[1] || (_cache[1] = [_createElementVNode("text", {
        style: {
          "display": "flex"
        }
      }, "未检测到购买记录", -1)]))]))])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]), marketProp.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: closeProp
      }, {
        default: _withCtx(() => [_createVNode(MarketPropsCard, {
          "prop-id": marketProp.value.id,
          onReload: getMarketData,
          onClose: closeProp
        }, null, 8, ["prop-id"])]),
        _: 1
      })) : _createCommentVNode("", true)], 4);
    };
  }

};